'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwipeBanner = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SwipeBanner, _Component);

  function SwipeBanner(props) {
    (0, _classCallCheck3.default)(this, SwipeBanner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SwipeBanner.__proto__ || (0, _getPrototypeOf2.default)(SwipeBanner)).call(this, props));

    _this.goToPrevSlide = function () {
      if (_this.state.currentIndex === 0) {
        return _this.setState({
          currentIndex: _this.props.images.length - 1,
          translateValue: -_this.divElement.clientWidth * (_this.props.images.length - 1)
        });
      }
      _this.setState(function (prevState) {
        return {
          currentIndex: prevState.currentIndex - 1,
          translateValue: prevState.translateValue + _this.divElement.clientWidth
        };
      });
    };

    _this.goToNextSlide = function () {
      if (_this.state.currentIndex === _this.props.images.length - 1) {
        return _this.setState({
          currentIndex: 0,
          translateValue: 0
        });
      }

      if (_this.divElement) {
        _this.setState(function (prevState) {
          return {
            currentIndex: prevState.currentIndex + 1,
            translateValue: prevState.translateValue - _this.divElement.clientWidth
          };
        });
      }
    };

    _this.state = {
      currentIndex: 0,
      translateValue: 0,
      touchStart: false,
      touchInitial: 0,
      touchMove: 0
    };
    _this.bannerAction = _this.bannerAction.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(SwipeBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setInterval = setInterval(this.goToNextSlide, 3000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.setInterval);
    }
  }, {
    key: 'handleTouchDown',
    value: function handleTouchDown(e) {
      var touch = e.touches[0];
      this.setState({
        touchStart: true,
        touchInitial: touch.clientX
      });
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(e) {
      var touch = e.touches[0];
      this.setState({
        touchMove: touch.clientX
      });
    }
  }, {
    key: 'handleTouchUp',
    value: function handleTouchUp() {
      var swipeDistance = this.state.touchInitial - this.state.touchMove;
      if (swipeDistance > 30) {
        this.goToNextSlide();
      } else if (swipeDistance < -30) {
        this.goToPrevSlide();
      }
      this.setState({
        touchStart: false
      });
    }
  }, {
    key: 'bannerAction',
    value: function bannerAction(item) {
      console.log('bannerAction', item);
      var link = item.link,
          name = item.name;
      var tracking = this.props.tracking;

      this.props.manualTrack((0, _extends3.default)({}, tracking, { label: name }));
      if (link && link.length) {
        if (link.startsWith('https')) {
          var win = window.open(link, '_blank');
          win.focus();
        }
        if (link.startsWith('/')) {
          this.props.history.push(link);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          images = _props.images,
          customImageStyle = _props.customImageStyle;
      var _state = this.state,
          currentIndex = _state.currentIndex,
          translateValue = _state.translateValue;

      var styles = require('./SwipeBanner.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.container },
        _react2.default.createElement(
          'div',
          {
            className: styles.slider,
            ref: function ref(divElement) {
              _this2.divElement = divElement;
            },
            onTouchStart: function onTouchStart(e) {
              return _this2.handleTouchDown(e);
            },
            onTouchMove: function onTouchMove(e) {
              return _this2.handleTouchMove(e);
            },
            onTouchEnd: function onTouchEnd() {
              return _this2.handleTouchUp();
            }
          },
          _react2.default.createElement(
            'div',
            {
              className: styles.slider_wrapper,
              style: {
                transform: 'translateX(' + translateValue + 'px)',
                transition: 'transform ease-out 0.45s'
              }
            },
            images.map(function (item, i) {
              return _react2.default.createElement(
                'div',
                {
                  key: i,
                  className: styles.slide,
                  onClick: function onClick() {
                    return _this2.bannerAction(item);
                  }
                },
                _react2.default.createElement('img', {
                  src: item.image,
                  className: customImageStyle ? customImageStyle : styles.itemImage
                })
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.dot },
          images && images.length > 1 && images.map(function (data, index) {
            if (currentIndex === index) {
              return _react2.default.createElement('img', {
                key: index,
                src: _Images2.default.home.activeDot,
                className: styles.dotStyle
              });
            } else if (currentIndex !== index) {
              return _react2.default.createElement('img', {
                key: index,
                src: _Images2.default.home.inactiveDot,
                className: styles.dotStyle
              });
            }
          })
        )
      );
    }
  }]);
  return SwipeBanner;
}(_react.Component), _class.propTypes = {
  customStyle: _react.PropTypes.string,
  customImageStyle: _react.PropTypes.string,
  history: _react.PropTypes.object,
  images: _react.PropTypes.array,
  tracking: _react.PropTypes.object,
  manualTrack: _react.PropTypes.func
}, _temp);
exports.default = SwipeBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/SwipeBanner.js
// module id = 1585
// module chunks = 0